// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { CustomerProductModel } from "@steiner/App/Store/Reducers";

const customerPartNumbersUrl = "api/str/customerpartnumber";

export interface CustomerPartNumbersApiParameter extends ApiParameter, HasPagingParameters {
    customerPartNumber?: string;
}

export interface DeleteCustomerPartNumberApiParameter extends ApiParameter {
    customerPartNumber?: string;
    productNumber?: string;
}

export interface UpdateCustomerPartNumberApiParameter extends ApiParameter {
    customerPartNumber?: string;
    productNumber?: string;
}

export interface CustomerPartNumbersModel extends HasPagingParameters {
    customerProducts?: CustomerProductModel[];
    pagination: PaginationModel | null;
}

export async function getCustomerPartNumbers(data: CustomerPartNumbersApiParameter): Promise<CustomerPartNumbersModel> {
    const customerPartNumbers = await get<CustomerPartNumbersModel>(
        `${customerPartNumbersUrl}/getcustomerpartnumbers`,
        data,
    );
    return customerPartNumbers;
}

// export async function deleteCustomerPartNumber(data: DeleteCustomerPartNumberApiParameter) {
//     await post(`${customerPartNumbersUrl}/deleteCustomerPartNumber`, {
//         customerPartNumber: data.customerPartNumber,
//         productNumber: data.productNumber,
//     });
// }
export async function deleteCustomerPartNumberService(data: DeleteCustomerPartNumberApiParameter) {
    try {
        const deleteCustomerResult = await post(`${customerPartNumbersUrl}/deleteCustomerPartNumber`, {
            customerPartNumber: data.customerPartNumber,
            productNumber: data.productNumber,
        });
        return {
            result: deleteCustomerResult,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
export async function updateCustomerPartNumber(data: UpdateCustomerPartNumberApiParameter) {
    await post(`${customerPartNumbersUrl}/updateCustomerPartNumber`, {
        customerPartNumber: data.customerPartNumber,
        productNumber: data.productNumber,
    });
}
